/**
 * Ryan O'Dowd
 * 2024-10-30
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import React from 'react';
import Text from '@components/common/Text';
import getStyles from './styles';
import hooks from '@hooks';

const EmptyScreenText = (props: EmptyScreenTextProps) => {
  const styles = hooks.useStyles(getStyles);

  return (
    <Text
      style={[
        styles.container,
        props.extraStyle, // @TODO: allow this to be an array?
      ]}
    >
      {props.children}
    </Text>
  );
};

class EmptyScreenTextProps {
  children: React.ReactNode;

  extraStyle?: any;
};

export default EmptyScreenText;
